import type { CodeToken } from './types'
export type { CodeToken } from './types'

const languageAliases = {
  bash: 'bash',
  c: 'c',
  cpp: 'cpp',
  cs: 'c_sharp',
  csharp: 'c_sharp',
  css: 'css',
  dart: 'dart',
  elixir: 'elixir',
  go: 'go',
  html: 'html',
  ini: 'toml',
  java: 'java',
  javascript: 'javascript',
  js: 'javascript',
  jsx: 'javascript',
  json: 'json',
  kotlin: 'kotlin',
  kt: 'kotlin',
  kts: 'kotlin',
  lua: 'lua',
  objc: 'objc',
  objectivec: 'objc',
  php: 'php',
  py: 'python',
  python: 'python',
  rb: 'ruby',
  rs: 'rust',
  ruby: 'ruby',
  rust: 'rust',
  scala: 'scala',
  sh: 'bash',
  swift: 'swift',
  toml: 'toml',
  ts: 'typescript',
  tsx: 'tsx',
  typescript: 'typescript',
  xml: 'html',
  yaml: 'yaml',
  yml: 'yaml',
} as const

export type TreeSitterLanguage =
  (typeof languageAliases)[keyof typeof languageAliases]

export async function tokenizeCode(
  code: string,
  language?: string,
): Promise<CodeToken[]> {
  const resolved = languageAliases[language as keyof typeof languageAliases]
  if (!resolved) return [{ text: code }]

  const engine = await import('./tree-sitter/engine')
  return engine.tokenizeWithTreeSitter(code, resolved)
}
